import { Maybe } from 'generated/graphql'

const formatAddress = (
  location?: Maybe<{
    addressLine1?: Maybe<string>
    city?: Maybe<string>
    state?: Maybe<string>
    zip?: Maybe<string>
    [key: string]: unknown
  }>
): string => {
  if (!location) {
    return ''
  }

  const { addressLine1 = '', city = '', state = '', zip = '' } = location

  const line = [addressLine1, city, state].filter(Boolean).join(', ').trim()

  return `${line} ${zip}`.trim()
}

export default formatAddress
